import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const StockTransferService = {

  getAllST: async () => {
    try {
      const response = await axios.get(ENDPOINT.StockTransfer);
      return response.data;
    } catch (error) {
      console.error("Error fetching Stock Transfers:", error.message);
      throw error;
    }
  },

  getSTStats: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.StockTransfer}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ST stats:", error.message);
      throw error;
    }
  },

  getLastST: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.StockTransfer}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching last ST:", error.message);
      throw error;
    }
  },

  getDistinctValues: async (field) => {
    try {
      const response = await axios.get(`${ENDPOINT.StockTransfer}/distinct/${field}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching distinct values:", error.message);
      throw error;
    }
  },

  getSTById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.StockTransfer}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching ST:", error.message);
      throw error;
    }
  },

  createST: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.StockTransfer, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating ST:", error.message);
      throw error;
    }
  },

  updateST: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.StockTransfer}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating ST:", error.message);
      throw error;
    }
  },

  updateStatus: async (id, status) => {
    try {
      const response = await axios.put(`${ENDPOINT.StockTransfer}/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error("Error updating ST status:", error.message);
      throw error;
    }
  },

  deleteST: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.StockTransfer}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting ST:", error.message);
      throw error;
    }
  },
};